import React, { useState } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Toolbar from '@material-ui/core/Toolbar';
import StyleLink from '@material-ui/core/Link';
import * as firebase from 'firebase';
import logo from '../img/pollinate-logo.png';

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";


const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,

    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
        font: 'lato',
    },
}));



export default function Appbar(props) {

    const [loggedIn, setLoggedIn] = useState(false);

    const handleLogout = () => {
        firebase.auth().signOut();
        setLoggedIn(false);
    }


    const classes = useStyles();
    return (
        <AppBar>
            <Toolbar>
                <img src={logo} alt="Logo" style={{width: '5rem'}}/>
                <Typography component="h5" variant="h5" style={{ font: 'lato' }} className={classes.title}>
                    Pollinate
                </Typography>

                <IconButton
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    color="inherit"
                >
                    <AccountCircle />
                </IconButton>

            </Toolbar>
        </AppBar>

    )
}


// WEBPACK FOOTER //
// ./src/components/appbar.js